import { ReactNode } from 'react';

import {
  Icons,
  SxProps,
  HexIcon,
  Typography,
  Stack,
  tokens,
} from '@cast/design-system';

type Props = {
  title: string;
  description: ReactNode;
  sx?: SxProps;
  testId?: string;
};

export const CollectingDataMessage = ({
  title,
  description,
  sx,
  testId = 'collecting-data-message',
}: Props) => {
  return (
    <Stack
      direction="row"
      flexWrap="nowrap"
      gap={16}
      sx={sx}
      data-testid={testId}
    >
      <HexIcon
        variant="notification"
        size={50}
        icon={<Icons.HourglassHigh weight="fill" />}
      />
      <Stack>
        <Typography variant="h5" data-testid="title">
          {title}
        </Typography>
        <Typography
          variant="P14R"
          color={tokens.theme.fg.structural.secondary}
          data-testid="description"
        >
          {description}
        </Typography>
      </Stack>
    </Stack>
  );
};
